import prochazkova from '../../resources/prochazkova.jpg'
import slezakova from '../../resources/slezakova.jpg'
import dohnal from '../../resources/dohnal.jpg'
import lehotsky from '../../resources/lehotsky.jpg'

export default {
  presenter: 'kuchapecha',
  title: 'Krátké Pecha Kucha přednášky',
  text: `
# Krátké Pecha Kucha přednášky

![Ivana Procházková](${prochazkova})

## Ivana Procházková - Síla prostředí

### aneb jak pořádek vnější vede k pořádku vnitřnímu

Často si ani neuvědomujeme, jak moc jsme ovlivněni prostředím,
ve kterém pracujeme nebo si hrajeme. Co všechno náš mozek musí zpracovat bokem při naší vědomé práci? Jak reaguje dítě na moc věcí a jak na věcí méně? Je opravdu tak důležité udržovat vnější řád, mít věci na svém místě, vlastní místo u stolu, vlastní postel? Umíme žít v chaosu dnešního světa a je žádoucí se mu přizpůsobovat? Může nám jasné prostředí dodat pocit bezpečí? Tímto a mnohým podobným se příspěvek bude zabývat.

Ivana je lektorka emoční inteligence dětí, kurzů pro rodiče a batolata, zakladatelka prvních Montessori jeslí v Brně, spoluautorka knihy S láskou i rozumem aneb využijte emoční inteligenci ve výchově, v neposlední řadě ovšem máma a nadšená pozorovatelka nejmenších dětí. Individuálně i skupinově pracuje s rodiči, dětmi i pedagogickými pracovníky.

![Petra Slezáková](${slezakova})

## Petra Slezáková - Zero Waste: Život bez odpadu

Stále viac sa v médiách hovorí o klimatických zmenách a globálnych dopadoch nášho konzumného života. Planéta je zahltená plastovým odpadom a stopy ľudskej činnosti sú viditeľné aj na opustených ostrovoch v strede Tichého oceánu. Je naozaj toto planéta, ktorú chceme odovzdať našim deťom? Aký podiel na tom má každý z nás? Môže zodpovedná spotreba radikálne znížiť množstvo odpadu na svete? Ako môžeme našu domácnosť nastaviť na život (skoro) bez odpadu?
Na workshope sa dozviete konkrétne tipy a triky ako na to. Spolu sa naučíme šetriť nielen životné prostredie, ale aj naše zdravie a peňaženku.

Petra vyštudovala Ekonomickú Univerzitu v Bratislave a 14 rokov pracovala v bankovníctve na Slovensku i v zahraničí. Aktívne žije štýlom zero waste, čiže sa snaží neprodukovať žiaden odpad. Je zakladateľkou úspešného blogu Zero Waste Slovakia. O svojom životnom štýle prednáša na školách a pre širokú verejnosť. Motivuje ľudí k zodpovednosti za svoju spotrebu a životné prostredie.

![Vítězslav Dohnal](${dohnal})

## Vítězslav Dohnal - Inovativní škola: teorie a realita

K čemu je škola? Kdo a proč chce mít inovativní školy a kdo by je mněl chtít? Co to je inovativní škola a jaká je ta normální? Je mezi nimi rozdíl? Rozdíl mezi tým být vzděláván a vzdělávat se. Učení a provázení, hodnocení a zpětná vazba. Důvěra ve školu jako práce s vlastním strachem. A možná ještě něco navíc.

Vystudoval sociologii na Masarykově univerzitě v Brně. Pedagogicky je dovzdělán filozofickou fakultou. Za jedno z nejhodnotnějších vzdělání však považuje to, jež se mu denně dostává od jeho dvou vlastních dětí a desítek těch školních. Zkušenosti získával při práci pro společnosti převážně v oboru informačních technologií, ale například i pro výrobce piva. Pět let vedl nadační fond zabývající se sportováním dětí s handicapem. Podílel se na otevření první ScioŠkoly na Jižní Moravě a druhým rokem je jejím ředitelem.

![Roman Lehotský](${lehotsky})

## Roman Lehotský

Predmetová olympiáda je vo všeobecnosti vnímaná ako bežná vedomostná súťaž. Jej postupové kolá, výberové a prípravné sústredenia a účasť na medzinárodnom kole však prináša žiakom oveľa viac. Učí ich systematickej práci, základným zásadám vedeckého výskumu a bádania, verejnej prezentácii, tým najlepším umožňuje vycestovanie do atraktívnych destinácií, otvára možnosti štúdia na prestížnych medzinárodných univerzitách, či získanie štipendijných pobytov.


Vyštudoval Prírodovedeckú fakultu UK v Bratislave. Viedol prírodovedné krúžky, organizoval poznávacie pobytové tábory pred deti, kurzy a exkurzie pre učiteľov. Aj vo svojom voľnom čase sa venuje neformálnemu vzdelávaniu organizovaním podujatí pre verejnosť v oblasti druhovej ochrany živočíchov a zachovania kultúrneho dedičstva. Už takmer 20 rokov sa profesijne venuje organizovaniu
predmetových olympiád a postupových súťaží, v súčasnosti v pozícií riaditeľa samostatného odboru organizácie IUVENTA – Slovenský inštitút mládeže.
  `,
}



// WEBPACK FOOTER //
// ./src/content/devdata/data/presentations/c04_pecha_kucha.js